/* ============================================================================
   Bold Grip Socks — influencer "claim your gift" flow.

   How it fires: the influencer shares a link of the form
     https://boldgripsocks.com/discount/ASHLEY?redirect=/?gift=Ashley
   Shopify applies the discount code ASHLEY (free Aegean Blue with a $25
   purchase), then redirects to /?gift=Ashley. This script reads ?gift=Ashley,
   silently adds one Aegean Blue to the cart, and shows a personalized toast:
     "Ashley gifted you a free Aegean Blue Sock!"  /  "Added to cart"

   The pair is only $0 at checkout once the cart meets the discount's $25
   minimum — that gate lives in the Shopify discount, not here.
   ========================================================================== */
(function () {
  var VARIANT   = 57931567956271; // Aegean Blue, one size
  var IMG       = 'https://cdn.shopify.com/s/files/1/0984/5496/2479/files/Aegean_Blue_Product_Shot.png?v=1781312588&width=180';
  var CLAIM_KEY = 'bm_gift_claimed_v1';
  var FADE_MS   = 4000;

  function getParam(n) {
    var m = new RegExp('[?&]' + n + '=([^&#]+)').exec(location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }
  function titleCase(s) {
    return s.trim().split(/\s+/).map(function (w) {
      return w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : '';
    }).join(' ');
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var raw = getParam('gift');
  if (!raw) return;

  // Sanitize hard: letters (incl. accented), spaces, hyphens, apostrophes only.
  var clean = raw.replace(/[^a-zA-ZÀ-ſ'\- ]/g, '').slice(0, 24).trim();
  var name  = titleCase(clean) || 'A friend';

  // Strip ?gift= from the URL so a refresh/share doesn't re-trigger.
  try {
    var u = new URL(location.href);
    u.searchParams.delete('gift');
    history.replaceState({}, document.title, u.pathname + u.search + u.hash);
  } catch (e) {}

  if (localStorage.getItem(CLAIM_KEY)) return; // already claimed on this device

  function updateBubble(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var span = b.querySelector('span[aria-hidden="true"]') || b;
      span.textContent = count;
    });
    document.querySelectorAll('.bm-hdr__act[href="/cart"]').forEach(function (a) {
      a.textContent = 'Bag (' + count + ')';
    });
  }

  function renderSections(sec) {
    if (!sec) return;
    try {
      if (sec['cart-drawer']) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          var doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
          var host = doc.querySelector('cart-drawer') || doc;
          var ni = host.querySelector('#CartDrawer');
          var oi = drawer.querySelector('#CartDrawer');
          if (ni && oi) oi.replaceWith(ni);
          drawer.classList.remove('is-empty');
        }
      }
      if (sec['cart-icon-bubble']) {
        var be = document.querySelector('#cart-icon-bubble');
        if (be) {
          var d2 = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html');
          var inner = d2.querySelector('div.shopify-section');
          be.innerHTML = inner ? inner.innerHTML : sec['cart-icon-bubble'];
        }
      }
    } catch (e) {}
  }

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var already = cart.items.some(function (i) { return i.variant_id === VARIANT; });
      if (already) { localStorage.setItem(CLAIM_KEY, '1'); toast(name); return; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: VARIANT, quantity: 1, properties: { '_gift': 'influencer:' + name } }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        localStorage.setItem(CLAIM_KEY, '1');
        renderSections(res.sections);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); });
      })
      .then(function (c2) {
        if (c2 && typeof c2.item_count !== 'undefined') updateBubble(c2.item_count);
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        toast(name);
      });
    })
    .catch(function () { /* fail silent — never block the page */ });

  function toast(displayName) {
    if (document.querySelector('[data-bm-gift-toast]')) return;
    var el = document.createElement('div');
    el.className = 'bm-gift-toast';
    el.setAttribute('data-bm-gift-toast', '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<img class="bm-gift-toast__img" src="' + IMG + '" alt="" aria-hidden="true" onerror="this.style.display=\'none\'">' +
      '<div class="bm-gift-toast__text">' +
        '<p class="bm-gift-toast__title">' + escapeHtml(displayName) + ' gifted you a free Aegean Blue Sock!</p>' +
        '<p class="bm-gift-toast__sub">Added to cart · free when you spend $25</p>' +
      '</div>' +
      '<button type="button" class="bm-gift-toast__x" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });

    var timer = setTimeout(dismiss, FADE_MS);
    function dismiss() {
      clearTimeout(timer);
      el.classList.remove('is-in');
      el.classList.add('is-out');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 500);
    }
    el.querySelector('.bm-gift-toast__x').addEventListener('click', dismiss);
  }
})();
